<!-- Contenedor botones navegación -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-pt-3 bg-blanco">
  <div class="p-col-12 p-sm-10 p-md-12 p-lg-10 p-xl-10 p-offset-0 p-xl-offset-1">
    <button pButton type="button" icon="pi pi-angle-left" label="Volver al inicio" routerLink="/" class="btn-primary-outline"></button>
  </div>
</div>
<!-- Fin navegación -->

<!-- Contenedor nombre curso -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-pb-5 p-pb-md-6 bg-blanco">
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-5">
    <h1 *ngIf="initializing">Cargando...</h1>
    <h1 @fadeIn *ngIf="!initializing">{{ curso.nombre }}</h1>
    <p><small>Versión del curso: {{version}}</small></p>
    <p>Para acceder a este curso deberás postular completando tus datos en un formulario de registro. Luego se enviará un correo de confirmación una vez que seas aceptado en el programa. Este proceso es automático </p>
    <small>Para algunos cursos será necesario contar con un código de acceso para postular.</small>
  </div>
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-4 p-text-right">
    <img width="100%"  src="assets/images/cursos_comunidad.svg"/>
  </div>
</div>
<!-- Fin contenedor nombre curso -->
 
<!-- Contenedor detalles curso -->
<div class="p-grid p-m-0 p-jc-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-gris">
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-5 p-offset-0 p-offset-xl-1">
    <h1>Acerca de este curso </h1>        
    <div *ngIf="initializing">Cargando más información para este curso...</div>
    <div @fadeIn *ngIf="!initializing" style="max-width: 960px;" [innerHTML]="curso.descripcion"></div>
    <p><br><br>
      <small class="text-muted">Si ya habías postulado a un curso, no podrás registrarte nuevamente, deberás iniciar sesión primero.</small>
    </p>
  </div>
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-4 p-text-center" >
    <div id="caracteristicas-curso">
      <div class="p-grid">
        <div class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6" *ngIf="initializing">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">                  
            <i class="pi pi-wallet p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span><b>Costo</b><br> cargando...</span>
          </div>
        </div>
        <div class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6" *ngIf="!initializing && curso.tipoCurso !== 'PRIVADO'">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">                  
            <i class="pi pi-wallet p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span @fadeIn *ngIf="curso.tipoCurso === 'GRATUITO'"><b>Costo</b><br> Gratuito</span>
            <span @fadeIn *ngIf="curso.tipoCurso !== 'GRATUITO'"><b>Costo</b>
              <i class="pi pi-info-circle p-ml-1" pTooltip="El pago se realiza una vez se acepta la postulación." tooltipPosition="bottom"></i>
              <br> Matrícula: ${{curso.valorMatricula}} <br> Arancel: ${{curso.valorArancel}} </span>
          </div>
        </div>
        <div class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6" *ngIf="!initializing && curso.requiereCodigo">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">
            <i class="pi pi-key p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span @fadeIn><b>Acceso</b><br> Requiere código de autorización</span>
          </div>
        </div>
        <div class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">
            <i class="pi pi-clock p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span *ngIf="initializing"><b>Duración</b><br> cargando...</span>
            <span @fadeIn *ngIf="!initializing"><b>Duración</b><br> {{ curso.duracion }} horas</span>
          </div>
        </div>
        <div *ngIf="!initializing" class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">
            <i class="pi pi-calendar p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span @fadeIn *ngIf="curso.fechaTermino">
              <b>Fecha inicio - término</b><br> 
              <span>{{curso.fechaInicio | date: 'dd/MM/yyyy' : 'UTC+0' }} - {{curso.fechaTermino | date: 'dd/MM/yyyy' : 'UTC+0' }}</span>
            </span>
            <span @fadeIn *ngIf="!curso.fechaTermino">
              <b>Fecha inicio</b><br> 
              <span>{{curso.fechaInicio | date: 'dd/MM/yyyy' : 'UTC+0' }}</span>
            </span>
          </div>
        </div>
        <div class="p-col-6 p-sm-6 p-md-6 p-lg-5 p-xl-6">
          <div class="p-card p-d-flex p-flex-column p-text-center" style="height: 100%;">
            <i class="pi pi-briefcase p-mr-2 p-mb-3" style="font-size: 4rem"></i>
            <span *ngIf="initializing"><b>Ofertado por</b><br> cargando...</span>
            <span @fadeIn *ngIf="!initializing && curso.facultad"><b>Ofertado por</b><br> Facultad de {{ curso.facultad }}.</span>
            <span @fadeIn *ngIf="!initializing && !curso.facultad"><b>Ofertado por</b><br> Universidad de Valparaíso.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-col-12 p-sm-10 p-md-12 p-lg-10 p-xl-10 p-offset-0 p-xl-offset-1">
    <div *ngIf="!initializing && curso.estado !== 'INACTIVO'">
      <!-- Código de acceso -->
      <div *ngIf="curso.requiereCodigo" class="pb-4">
        <p class="p-pb-2"><p-message severity="warn" text="Este curso requiere un código de acceso. Ingrese el código a continuación."></p-message></p>
        <span class="p-float-label p-mt-3">
          <input 
            class="p-inputtext" 
            [minLength]="5" 
            [maxLength]="10" 
            (keyup)="keyPressAlphanumeric($event)" 
            [readonly]="codigoValido" 
            [disabled]="codigoValido || validating" 
            id="codigoAcceso" 
            type="text"
            [(ngModel)]="codigoAcceso" 
            pInputText 
          />
          <label for="codigoAcceso">Código de acceso</label>
          <i *ngIf="codigoValido" class="pi pi-check-circle p-ml-2" style="font-size: 1.2rem; color: green;"></i>
          <i *ngIf="!codigoValido && mensajeCodigo.length > 0" class="pi pi-times-circle p-ml-2" style="font-size: 1.2rem; color: red;"></i>
        </span>
      </div>
      <div *ngIf="mensajeCodigo && mensajeCodigo.length > 0 && codigoAcceso && codigoAcceso.length >= 5"
        class="p-col-12 p-pt-2 pb-3">
        <span [ngStyle]="codigoValido ? {color: '#232c70'} : {color: 'red'}">{{mensajeCodigo}}</span>
      </div>
      <div *ngIf="curso.requiereCodigo && !codigoValido" class="p-py-2">
        <button 
          pButton 
          type="button" 
          [disabled]="!codigoAcceso || codigoAcceso.length < 5"
          (click)="validarCodigoAcceso()" icon="pi pi-unlock"
          [label]="validating ? 'Validando, espere...' : 'Validar código'" 
          [loading]="validating"
          class="p-mt-2 btn-secondary">
        </button>
      </div>
      <!-- Fin coódigo acceso -->
      <div *ngIf="!this.sessionService.isLogged() && (!curso.requiereCodigo || codigoValido)" class="p-pt-2">
        <button 
          pButton 
          type="button" 
          routerLink="/postulacion"
          [queryParams]="{ curso_id: curso_id, version: version, codigoAcceso: codigoAcceso }" 
          icon="pi pi-check-circle"
          label="Registra tu datos y postula ahora" 
          [loading]="validating"
          class="p-mt-2 btn-primary">
        </button>
      </div>
      <div *ngIf="!this.sessionService.isLogged() && (!curso.requiereCodigo || codigoValido)" class="p-pt-2">
        <button 
          pButton 
          type="button" 
          routerLink="/login"
          [queryParams]="{ curso_id: curso_id, version: version, codigoAcceso: codigoAcceso }" 
          icon="pi pi-sign-in"
          label="¿Ya tienes una cuenta? Inicia sesión"
          class="p-mt-2 btn-white"></button>
      </div>
      <div *ngIf="this.sessionService.isLogged() && (!curso.requiereCodigo || codigoValido)" class="p-pt-2">
        <app-modal-postulacion [curso_id]="curso_id" [version]="version"></app-modal-postulacion>
      </div>
    </div>
    <div *ngIf="!initializing && curso.estado == 'INACTIVO'">
      <p-message severity="warn" text="El curso ya no se encuentra disponible para postular.">
      </p-message>
    </div>
  </div>
</div>
<!-- Fin detalle curso -->

<!-- Contenedor cursos gratuitos -->
<div id="cursos" class="bg-azul">
  <div class="p-grid p-jc-center p-m-0" style="background-color: transparent; z-index: 99; position: relative;">
    <div class="p-col-11 p-sm-11 p-md-11 p-lg-10 p-xl-7 p-offset-1 p-py-3 py-md-4 p-px-3 p-m-0 p-text-center">
      <h1 class="p-mr-3">Cursos <span style="font-weight: 700;">Gratuitos</span></h1>
      <p @fadeInUp>No olvides revisar los cursos gratuitos que tenemos en nuestra plataforma.</p>
    </div>
    <div class="p-col-11 p-sm-11 p-md-11 p-lg-10 p-xl-8 p-offset-1 p-pb-2 p-m-0 p-px-3">
      <app-cursos-carousel [cursos]="cursosGratuitos" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
    </div>
  </div>
  <div class="wave">
     <img src="assets/images/wave.svg" />
  </div>
</div>
<!-- Fin cursos gratuitos -->

  
